import React, { useState, useMemo, useEffect, useCallback } from "react";
// import PropTypes from "prop-types";
import axios from "axios";
import { DataTable } from "components/DataTable/DataTable";
import { DataViewContainer } from "components/DataViewContainer/DataViewContainer";
import SelectColumnFilter from "components/DataTable/SelectColumnFilter";
import DateFilter from "components/DataTable/DateFilter";
import moment from "moment";

const MasterClaimDetail = (props) => {
  const [data, setData] = useState([]);
  const [yearData, setYearData] = useState([]);
  const [enableCSV, setEnableCSV] = useState(0);
  const [loading, setLoading] = useState(true);
  const { currentUser, path } = props;
  const currentYear = moment().format("YYYY");
  const currentMonth = moment().format("M");

  const columns = useMemo(() => [
    {
      Header: "Claim ID",
      accessor: "ClaimID",
    },
    {
      Header: "Accession",
      accessor: "Accession",
    },
    {
      Header: "Test Type",
      accessor: "TestType",
    },
    {
      Header: "Type",
      accessor: "Type",
    },
    {
      Header: "Patient Name",
      accessor: "PatientName",
    },
    {
      Header: "DOB",
      accessor: "DOB",
    },
    {
      Header: "DOS",
      accessor: "DOS",
      Filter: DateFilter,
      filter: "dateBetween",
    },
    {
      Header: "Cla Status",
      accessor: "ClaStatus",
      Filter: SelectColumnFilter,
      filter: "includes",
    },
    {
      Header: "Cla Class",
      accessor: "CLaClassification",
    },
    {
      Header: "Attn Flag",
      accessor: "AttnLevelFlag",
    },
    {
      Header: "Primary Payer",
      accessor: "PrimaryPayer",
    },
    {
      Header: "PriInsClaFilingInd",
      accessor: "PriInsClaFilingInd",
      Filter: SelectColumnFilter,
      filter: "includes",
    },
    {
      Header: "Bill Date",
      accessor: "BillDate",
      // Filter: DateFilter,
      // filter: "dateBetween",
    },
    {
      Header: "Total Charge",
      accessor: "TotalCharge",
    },
    {
      Header: "Total Balance",
      accessor: "TotalBalance",
    },
    {
      Header: "Total Paid",
      accessor: "InsAmtPaid",
    },
    {
      Header: "Closed Date",
      accessor: "PaidDate",
      // Filter: DateFilter,
      // filter: "dateBetween",
    },
    {
      Header: "Ins Balance",
      accessor: "InsBalance",
    },
    {
      Header: "Patient Balance",
      accessor: "PatientBalance",
    },
    {
      Header: "Clinic",
      accessor: "Clinic",
    },
    {
      Header: "Physician",
      accessor: "Physician",
    },
    {
      Header: "Sales Rep",
      accessor: "SalesRep",
    },
    {
      Header: "Supervising Rep",
      accessor: "SupervisingRep",
    },
    {
      Header: "Modified",
      accessor: "Modified",
    },
  ]);

  // Function to query data based off of rep and admin roles
  const fetchData = useCallback(async (user, cy, cm) => {
    let url;
    let result;
    if (user.role === "Admin") {
      url = `${process.env.REACT_APP_REST_API_HOST}adminmasterclaimmonthly?year=${cy}&month=${cm}&apikey=${process.env.REACT_APP_REST_API_KEY}`;
      result = await axios.get(url);
      setLoading(false);
      setData(result.data);
    } else if (user.email && user.role === "Rep") {
      url = `${process.env.REACT_APP_REST_API_HOST}repmasterclaimmonthly?user_email=${user.email}&year=${cy}&month=${cm}&apikey=${process.env.REACT_APP_REST_API_KEY}`;
      result = await axios.get(url);
      setLoading(false);
      setData(result.data);
    } else {
      setLoading(false);
      setData([]);
    }
  }, []);

  // Function to query data based off of rep and admin roles
  const fetchYearData = useCallback(async (user, cy) => {
    let url;
    let result;
    if (user.email && user.role === "Rep") {
      setEnableCSV(1);
      url = `${process.env.REACT_APP_REST_API_HOST}repmasterclaimmonthly?user_email=${user.email}&year=${cy}&apikey=${process.env.REACT_APP_REST_API_KEY}`;
      result = await axios.get(url);
      setEnableCSV(2);
      setYearData(result.data);
    } else if (user.role === "Admin") {
      setEnableCSV(1);
      url = `${process.env.REACT_APP_REST_API_HOST}adminmasterclaimmonthly?year=${cy}&apikey=${process.env.REACT_APP_REST_API_KEY}`;
      result = await axios.get(url);
      setEnableCSV(2);
      setYearData(result.data);
    } else {
      setEnableCSV(2);
      setYearData([]);
    }
  }, []);

  // Fetch data
  useEffect(() => {
    fetchData(currentUser, currentYear, currentMonth);
  }, [fetchData, currentUser, currentMonth, currentYear]);

  return (
    <DataViewContainer
      pageTitle="Master Claim Detail Data"
      loading={loading}
      fetchData={fetchData}
      currentUser={currentUser}
      setLoading={setLoading}
      path={path}
    >
      {!loading ? (
        <>
          <DataTable
            data={data}
            columns={columns}
            yearData={yearData}
            enableCSV={enableCSV}
            fetchYearData={fetchYearData}
            currentUser={currentUser}
          />
        </>
      ) : undefined}
    </DataViewContainer>
  );
};

export default MasterClaimDetail;
